<main class="main">
  <section class="glossary-card card-direction">
    <div class="card-header">
      <h2 class="card-title">{{ 'glossary.companyDesc' | transloco }}</h2>
      <button *ngIf="!isEditCompany" type="button" class="edit-direction-button" (click)="startEditCompanyDesc()">
        <span class="btn-icon btn-icon-pencil-white" aria-hidden="true"></span>
        {{ 'glossary.editButton' | transloco }}
      </button>
    </div>
    <div class="card-body">
      <textarea *ngIf="isEditCompany"
                class="input-direction"
                [(ngModel)]="companyDesc"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                [placeholder]="'content.emptyElement' | transloco"></textarea>
      <p *ngIf="!isEditCompany" class="direction-text">
        {{ companyDesc ?? ('content.emptyElement' | transloco) }}
      </p>
      <div *ngIf="isEditCompany" class="direction-actions">
        <button type="button" class="btn-primary" (click)="saveCompanyDesc()">
          <span class="btn-icon btn-icon-save" aria-hidden="true"></span>
          {{ 'content.save' | transloco }}
        </button>
        <button type="button" class="btn-secondary" (click)="cancelEditCompanyDesc()">
          <span class="btn-icon btn-icon-close" aria-hidden="true"></span>
          {{ 'glossary.cancel' | transloco }}
        </button>
      </div>
    </div>
  </section>

  <section class="glossary-card card-glossary">
    <div class="card-header">
      <h2 class="card-title">{{ 'glossary.glossaryTitle' | transloco }}</h2>
      <div class="card-actions">
        <input #importFileInput type="file" accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" (change)="onImportFile($event)" style="display: none" />
        <button type="button" class="btn-outline" (click)="triggerImport()">
          <span class="btn-icon btn-icon-upload" aria-hidden="true"></span>
          {{ 'glossary.download' | transloco }}
        </button>
        <button type="button" class="btn-outline" (click)="exportExcel()">
          <span class="btn-icon btn-icon-download" aria-hidden="true"></span>
          {{ 'glossary.export' | transloco }}
        </button>
        <button type="button" class="btn-primary" (click)="openTermModal()">
          <span class="btn-icon btn-icon-plus" aria-hidden="true"></span>
          {{ 'glossary.addTerm' | transloco }}
        </button>
      </div>
    </div>

    <div class="search-wrap">
      <span class="search-icon" aria-hidden="true"></span>
      <input type="text"
             class="search-input"
             [(ngModel)]="searchTerm"
             [placeholder]="'glossary.searchPlaceholder' | transloco"
             aria-label="Поиск по терминам" />
    </div>

    <div class="table-wrap">
      <table class="glossary-table">
        <thead>
          <tr>
            <th>{{ 'glossary.columnTerm' | transloco }}</th>
            <th>{{ 'glossary.columnDescription' | transloco }}</th>
            <th class="th-actions">{{ 'glossary.columnActions' | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of filteredData">
            <td>{{ row.term }}</td>
            <td>{{ row.meaning }}</td>
            <td class="td-actions">
              <div class="row-actions">
                <button type="button" class="btn-icon-only btn-edit" (click)="openTermModal(row)" [title]="'content.edit' | transloco">
                  <span class="btn-icon btn-icon-pencil-purple" aria-hidden="true"></span>
                </button>
                <button type="button" class="btn-icon-only btn-delete" (click)="deleteRow(row)" [title]="'glossary.deleteTerm' | transloco">
                  <span class="btn-icon btn-icon-trash" aria-hidden="true"></span>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <footer class="table-footer">
      {{ 'glossary.totalTerms' | transloco }}: {{ data.length }}
    </footer>
  </section>

  <div *ngIf="termModalOpen" class="modal-backdrop" (click)="closeTermModal()">
    <div class="modal-dialog add-term-modal" (click)="$event.stopPropagation()" appCloseOnEscape (onEscape)="closeTermModal()">
      <button type="button" class="modal-close" (click)="closeTermModal()" [attr.aria-label]="'dialog.close' | transloco">&times;</button>
      <h3 class="modal-title">{{ (editingTermRow ? 'glossary.editTermTitle' : 'glossary.addTerm') | transloco }}</h3>
      <div class="modal-body">
        <div class="row">
          <label class="modal-label">{{ 'glossary.columnTerm' | transloco }}</label>
          <input type="text"
                 class="modal-input"
                 [(ngModel)]="modalTermName"
                 [placeholder]="'glossary.termPlaceholder' | transloco"
                 (keydown.enter)="$event.preventDefault(); submitTermModal()" />
        </div>
        <div class="row">
          <label class="modal-label">{{ 'glossary.columnDescription' | transloco }}</label>
          <textarea class="modal-textarea"
                    [(ngModel)]="modalTermDescription"
                    [placeholder]="'glossary.descriptionPlaceholder' | transloco"
                    rows="4"></textarea>
        </div>
      </div>
      <div class="modal-actions">
        <button type="button" class="btn-secondary" (click)="closeTermModal()">
          {{ 'glossary.cancel' | transloco }}
        </button>
        <button type="button" class="btn-primary" (click)="submitTermModal()" [class.disabled]="isTermNameEmpty" [disabled]="isTermNameEmpty" >
          {{ (editingTermRow ? 'content.save' : 'glossary.add') | transloco }}
        </button>
      </div>
    </div>
  </div>
</main>
